import {h, Fragment} from "preact"
import { noResultLinks, NORESULTS_RECID } from "../config"

export default function NoResults() {

    return (
        <div class="ns-noresults">
            <div class="wrapper">
                <div class="section-heading">
                    <h1 class="ns-noresults-heading">Uh oh, there are no results for your search.</h1>
                    <p class="ns-noresults-subheading">But you've come to the right place - let's find an outfit right for you.</p>
                </div>
                <div class="ns-noresults-collections">
                    <div class="ns-noresults-grid ns-grid ns-w-100">
                        {noResultLinks.map(item => (
                            <div key={item.url} class="ns-noresults-collection-item">
                                <a class="btn btn--primary btn--full" href={item.url}>{item.text}</a>
                            </div>
                        ))}
                    </div>
                    <div class="ns-noresults-collection-item ns-home-link">
                        <a class="btn btn--secondary btn--full" href="/">Go Home</a>
                    </div>
                </div>
                
                <nosto-campaign
                    placement={NORESULTS_RECID}
                    id={NORESULTS_RECID}
                />

            </div>
        </div>
    )
}
